import React from 'react';
import { withNamespaces } from 'react-i18next';
import ProgressButton from '../../Global/Buttons/Progress';
import classnames from 'classnames';

export const RatesEmptyState = ({ t, classes, onClick, isSubmitting }) => (
  <ProgressButton
    variant="contained"
    color="primary"
    className={classnames(classes.button, classes.getRatesButton)}
    classes={{
      label: classnames(classes.buttonLabel, classes.getRatesButtonLabel)
    }}
    onClick={onClick}
    isSubmitting={isSubmitting}
  >
    {t('Get Rates')}
  </ProgressButton>
);

const RatesEmptyStateWithTranslations = withNamespaces()(RatesEmptyState);
export default RatesEmptyStateWithTranslations;
